/* global Hover */

import { eventChannel } from 'redux-saga';

/**
 * Create Event listeners for when the machete model is ready
 * @returns {Object} EventListener state is changed according to the event
 */
const macheteModelReady = () =>
  eventChannel((emit) => {
    Hover.BuildingManager.addEventListener('modelready', emit);
    return () => Hover.BuildingManager.removeEventListener('modelready', emit);
  });

export default macheteModelReady;
